import { useMutation } from '@apollo/client';
import { PricingTaxi } from '../../shared/types';
import { CITRIN_CREATE_PRICING_TAXI, CreatePricingTaxiRequest, CreatePricingTaxiResponse } from '..';

type CreateMutationFunction = (request: PricingTaxi) => Promise<PricingTaxi>;
export const useCreatePricingTaxiMutation = (): { mutation: CreateMutationFunction; loading: boolean } => {
    const [mutation, { loading }] = useMutation<CreatePricingTaxiResponse, CreatePricingTaxiRequest>(
        CITRIN_CREATE_PRICING_TAXI
    );
    const promiseMutation = async (request) => {
        const result = await mutation({
            variables: { request },
        });
        return result.data.CITRIN_MGT_createPricingTaxi;
    };

    return {
        mutation: promiseMutation,
        loading,
    };
};
